// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__L9IfL"};